import { AuthTokens, AuthUser, AuthStorage, AuthEvents } from './types';
import { CapicheLoggerCore } from '@capiche/ts-logger-core';

export class CapicheAuthCore {
  private storage: AuthStorage;
  private events?: AuthEvents;
  private currentUser: AuthUser | null = null;
  private tokens: AuthTokens | null = null;
  private logger: CapicheLoggerCore;

  constructor(storage: AuthStorage, events?: AuthEvents, logEnabled = false) {
    this.logger = new CapicheLoggerCore('ts-auth-core:', logEnabled);
    this.storage = storage;
    this.events = events;
  }

  async init(): Promise<void> {
    const stored = await this.storage.getTokens();
    this.logger.log('init', stored);
    if (stored) {
      this.tokens = stored;
      this.currentUser = this.decodeUserFromIdToken(stored.idToken);
    }
  }

  async login(idToken: string, refreshToken?: string): Promise<void> {
    const user = this.decodeUserFromIdToken(idToken);
    this.logger.log('login', user);
    const tokens = {
      idToken,
      refreshToken,
      expiresAt: this.getTokenExpiry(idToken),
    };
    this.tokens = tokens;
    this.currentUser = user;
    await this.storage.saveTokens(tokens);
    this.events?.onLogin?.(user);
  }

  async logout(): Promise<void> {
    this.logger.log('logout');
    this.tokens = null;
    this.currentUser = null;
    await this.storage.clearTokens();
    this.events?.onLogout?.();
  }

  getUser(): AuthUser | null {
    this.logger.log('getUser', this.currentUser);
    return this.currentUser;
  }

  getIdToken(): string | null {
    this.logger.log('getIdToken', this.tokens);
    return this.tokens?.idToken ?? null;
  }

  private decodeUserFromIdToken(idToken: string): AuthUser {
    this.logger.log('decodeUserFromIdToken', idToken);
    const [, payload] = idToken.split('.');
    const json = atob(payload);
    return JSON.parse(json);
  }

  private getTokenExpiry(idToken: string): number | undefined {
    this.logger.log('getTokenExpiry', idToken);
    const [, payload] = idToken.split('.');
    const json = atob(payload);
    const { exp } = JSON.parse(json);
    return exp;
  }
}
